module.exports = __webpack_public_path__ + "img/ambulance.999bcf3f.svg";